<template>
    <b-container>
        <div class="class-list">
              <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="classes"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditClass', params: { id: row.item.uuid } }"
                    >{{ row.item.name }}</b-link
                    >
                  
                </template>
                 
                <template slot="cell(active)" slot-scope="row">
                   
                   <b-form-radio-group
                    :id="row.index.toString()"
                    :value="row.item.active"
                    v-model="row.item.active"
                    @change="updateClass(row.item)"
                    >
                    <b-form-radio :value="true">True</b-form-radio>
                    <b-form-radio :value="false">False</b-form-radio>
                    </b-form-radio-group>
                </template>
                </b-table>
                <b-row>
                    <b-col md="6" class="my-1">
                        <b-pagination
                        :total-rows="classes.length || 0"
                        :per-page="perPage"
                        v-model="currentPage"
                        class="my-0"
                        />
                    </b-col>
                </b-row>
        </div>
    </b-container>
</template>
<script>
import ClassService from "../services/ClassService";
export default {
     name: "TrainerClasses",
     data(){
        return{
            fields: [
                { key: "name", label: "Class", sortable: true },
                { key: "teacher_name", label: "Teacher" },
                { key: "school_name", label: "School" },
                { key: "active", label: "Active" },
            
            ],
            currentPage: 1,
            perPage: 5,
            filter: null,
            classes:[]
        }
     },
     methods:{
        stopClick() {},
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
          async updateClass(params) {
            console.log(params);
            const payload = await {
                id: params.id,
                active: params.active,
            };
            await ClassService.updateClass(payload);
        }
     },
     async created(){
        // console.log(await ClassService.getTrainerClass(this.$route.params.id).data);
        const classList =  await ClassService.getTrainerClass(this.$route.params.id);
        this.classes = classList.data.results
     }
}
</script>